//#region Types
import { ChartEnums } from "models/enums";
//#endregion
import { WintSuperkollAPIModelAnnualAccounts } from "wint-api-client/dist/types";

export const useTimelineStepState = () => {
  return (
    annualReportState: WintSuperkollAPIModelAnnualAccounts.SuperkollAnnualReportState,
    auditorState: WintSuperkollAPIModelAnnualAccounts.SuperkollAuditorAnnualReportState,
    totalSteps: number
  ): ChartEnums.TimelineStepType[] => {
    const orderedStates = [
      {
        type: "customer",
        match: () =>
          annualReportState === WintSuperkollAPIModelAnnualAccounts.SuperkollAnnualReportState.AnnualReportSigningStarted &&
          auditorState !== WintSuperkollAPIModelAnnualAccounts.SuperkollAuditorAnnualReportState.SigningStartedForAuditor,
      },
      {
        type: "auditor",
        match: () =>
          auditorState === WintSuperkollAPIModelAnnualAccounts.SuperkollAuditorAnnualReportState.SigningStartedForAuditor,
      },
      {
        type: "auditor",
        match: () =>
          auditorState === WintSuperkollAPIModelAnnualAccounts.SuperkollAuditorAnnualReportState.WaitingForAuditReport ||
          auditorState === WintSuperkollAPIModelAnnualAccounts.SuperkollAuditorAnnualReportState.WaitingOnAuditorSign,
      },
      {
        type: "customer",
        match: () =>
          annualReportState === WintSuperkollAPIModelAnnualAccounts.SuperkollAnnualReportState.GeneralMeetingSigningStarted,
      },
      {
        type: "customer",
        match: () =>
          annualReportState === WintSuperkollAPIModelAnnualAccounts.SuperkollAnnualReportState.XbrlFileSubmitted,
      },
    ];

    const currentIndex = orderedStates.findIndex((step) => step.match());

    return Array.from({ length: totalSteps }, (_, index) => {
      if (index < currentIndex) return ChartEnums.TimelineStepType.Done;
      if (index === currentIndex) return ChartEnums.TimelineStepType.InProgress;
      return ChartEnums.TimelineStepType.NotStarted;
    });
  };
};
